
import withTracker from './tracker';

import {
    EmailNum,
    Password,
    Forget,
    SetPwd,
    Update,
    NewPwd,
    Profile,
    Age,
    Guardian,
    Agreement,
    Ifttt,
    About,
    Feedback,
    ConfirmLogout,
    ProjectDelete,
    UpdaterAppChecker,
    UserDelete,
    Share,
    ShareSuccess,
    CancelShare
} from './lazy-routers';

export default [
    {
        url: '/list/login',
        component: withTracker(EmailNum),
        exact: true
    },
    {
        url: '/list/login/:type',
        component: withTracker(Password),
    },
    {
        url: '/list/profile',
        component: withTracker(Profile),
        exact: true
    },
    {
        url: '/list/profile/delete',
        component: withTracker(UserDelete)
    },
    {
        url: '/list/forget',
        component: withTracker(Forget),
        exact: true
    },
    {
        url: '/list/forget/setPwd',
        component: withTracker(SetPwd)
    },
    {
        url: '/list/update',
        component: withTracker(Update),
        exact: true
    },
    {
        url: '/list/update/newPwd',
        component: withTracker(NewPwd)
    },
    {
        url: '/list/age',
        component: withTracker(Age)
    },
    {
        url: '/list/guardian',
        component: withTracker(Guardian)
    },
    {
        url: '/list/agreement',
        component: withTracker(Agreement)
    },
    {
        url: '/list/user/ifttt',
        component: Ifttt
    },
    {
        url: '/list/help/about',
        component: withTracker(About)
    },
    {
        url: '/list/help/feedback',
        component: withTracker(Feedback)
    },
    {
        url: '/list/confirm/logout',
        component: withTracker(ConfirmLogout)
    },
    {
        url: '/list/project/delete/:id',
        component: withTracker(ProjectDelete)
    },
    {
        url: '/list/updater/app/checker',
        component: UpdaterAppChecker,
        exact: true
    },
    {
        url: '/list/project/share/:id',
        component: Share
    },
    {
        url: '/list/project/shareSuccess/:id',
        component: ShareSuccess
    },
    {
        url: '/list/project/cancelShare/:id',
        component: CancelShare
    }
];